"use client";

import { NavButton } from "@/components/nav-button";
import { getHotelFunnelReturnUrlFromDocument } from "@/lib/checkout/integration-source";
import { HTMLAttributeAnchorTarget, useEffect, useState } from "react";

export type HotelAwareNavButtonProps = {
  href: string;
  hotelLabel: string;
  children: React.ReactNode;
  sticky?: boolean;
  linkTarget?: HTMLAttributeAnchorTarget;
};

export function HotelAwareNavButton({
  href,
  hotelLabel,
  children,
  sticky,
  linkTarget,
}: HotelAwareNavButtonProps) {
  const [hotelUrl, setHotelUrl] = useState<string>();

  useEffect(() => {
    setHotelUrl(getHotelFunnelReturnUrlFromDocument());
  }, []);

  return (
    <NavButton href={hotelUrl ?? href} sticky={sticky} linkTarget={linkTarget}>
      {hotelUrl ? hotelLabel : children}
    </NavButton>
  );
}
